import React, {FC} from 'react';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {STEPS} from '../../constants/checkout';
import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {PaymentsMethodsConnected} from '../paymentsMethods/paymentsMethods';
import {StepBody} from '../stepBody/stepBody';
import {StepTitle} from '../stepTitle/stepTitle';
import {StepWrapper} from '../stepWrapper/stepWrapper';
import {TaxWarningConnected} from '../taxWarning/taxWarning';

type PropsType = {
    currentStep: STEPS;
};

/**
 * Payment Step for checkouts
 *
 * @constructor
 */
export const PaymentStep: FC<PropsType> = ({currentStep}) => {
    return (
        <StepWrapper step={STEPS.PAYMENT_STEP}>
            <StepTitle currentStep={currentStep} step={STEPS.PAYMENT_STEP}>
                Payment
                <TaxWarningConnected />
            </StepTitle>
            <StepBody currentStep={currentStep} step={STEPS.PAYMENT_STEP}>
                <PaymentsMethodsConnected />
            </StepBody>
        </StepWrapper>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    currentStep: getCurrentStep(store),
});

export const PaymentStepConnected = connect(mapStateToProps)(PaymentStep);
